import styled from 'styled-components';

// Implementacao do design Operacional.html (handoff bundle Claude Design).
// Estrutura: topbar 1 row 3-col (crumbs | machine-card | status-block) +
// body 2-col (left scene+resumo | right rail). Match exato dos tokens
// e medidas do prototipo.

// Container — height 100vh fixo + overflow hidden trava a pagina na
// viewport. Cada coluna (LeftColumnGrid / RightColumnGrid) scrolla
// internamente onde precisar.
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100vw - 64px);
  height: 100vh;
  margin: 0 0 0 64px;
  padding: 0;
  box-sizing: border-box;
  background: var(--cco-bg);
  color: var(--cco-ink);
  overflow: hidden;

  @media (max-width: 1100px) {
    height: auto;
    min-height: 100vh;
    overflow: visible;
  }

  @media (max-width: 720px) {
    width: 100vw;
    margin: 0;
  }
`;

// ============================================================
// TOPBAR — 1 row dividida em 3 colunas separadas por hairline:
//   auto (crumbs) | minmax(280px, 1fr) (machine-card) | auto (status-block)
// ============================================================
// Grid 3-col: crumbs (auto) | machine-card (1fr) | status (auto).
// minmax(0, ...) nas duas ultimas permite que o slot de status encolha
// e os 5 toggles façam wrap quando viewport e menor que ~1500px.
export const HeaderBar = styled.section`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) minmax(0, auto);
  align-items: stretch;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid var(--cco-line);

  > * + * {
    border-left: 1px solid var(--cco-line);
  }

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
    > * + * {
      border-left: none;
      border-top: 1px solid var(--cco-line);
    }
  }
`;

// Crumbs: back btn + breadcrumb trail (Dashboard › Parque › Usina › Operacional)
export const HeaderSlotLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 28px 16px var(--cco-pad);
  min-width: 0;
`;

// Machine-card: badge cyan + ttl + sub
export const HeaderSlotCenter = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 24px;
  min-width: 0;

  @media (max-width: 1280px) {
    flex-wrap: wrap;
  }
`;

export const RangeAlertBanner = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  max-width: min(520px, 46vw);
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid
    ${(props) =>
      props.$alarm ? 'rgba(255, 77, 109, 0.55)' : 'rgba(255, 223, 89, 0.55)'};
  background: ${(props) =>
    props.$alarm ? 'rgba(255, 77, 109, 0.12)' : 'rgba(255, 223, 89, 0.1)'};
  color: ${(props) => (props.$alarm ? '#ff4d6d' : '#ffe05d')};
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.03);

  @media (max-width: 1100px) {
    max-width: 100%;
  }
`;

export const RangeAlertKicker = styled.span`
  flex: none;
  font-size: 10px;
  font-weight: 800;
  line-height: 1;
  text-transform: uppercase;
  color: currentColor;
`;

export const RangeAlertText = styled.span`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  font-size: 12px;
  line-height: 1.15;
  color: var(--cco-ink);

  strong,
  span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  strong {
    font-size: 13px;
    font-weight: 800;
    color: currentColor;
  }

  span {
    color: var(--cco-ink-mute);
  }
`;

// Status-block: label STATUS pill + 5 toggle pairs
export const HeaderSlotRight = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 14px var(--cco-pad);
  min-width: 0;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    gap: 10px;
    padding: 10px var(--cco-pad);
  }
`;

// ============================================================
// BODY — 2-col: left scene+resumo (1fr) | right rail (460px)
// ============================================================
// Body grid 2-col. flex 1 + min-height 0 + overflow hidden permite que
// cada coluna controle seu proprio scroll (.left rola scene+resumo
// quando passa, .rail rola so as vars).
export const NewContainerBody = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 460px;
  width: 100%;
  box-sizing: border-box;
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;

  > * + * {
    border-left: 1px solid var(--cco-line);
  }

  @media (max-width: 1400px) {
    grid-template-columns: minmax(0, 1fr) 400px;
  }
  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
    overflow: visible;
    > * + * {
      border-left: none;
      border-top: 1px solid var(--cco-line);
    }
  }
`;

// Coluna esquerda — Scene head + Scene frame + Resumo. overflow-y auto
// pra scrollar se o conteudo passar (em viewports curtos).
export const LeftColumnGrid = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  min-height: 0;
  box-sizing: border-box;
  overflow-y: auto;

  > * + * {
    border-top: 1px solid var(--cco-line);
  }
`;

// Coluna direita (rail) — flex column com overflow hidden. As variaveis
// fluem dentro do List que controla o scroll interno via .vars.
export const RightColumnGrid = styled.aside`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  min-height: 0;
  box-sizing: border-box;
  overflow: hidden;
`;

// ============================================================
// SCENE-HEAD — chip "Máquina" cyan + texto "Máquina <NOME>"
// ============================================================
export const SceneHead = styled.section`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px var(--cco-pad) 14px;
  width: 100%;
  box-sizing: border-box;
`;

export const SceneHeadChip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 999px;
  background: var(--cco-cyan-soft);
  color: var(--cco-cyan);
  box-shadow: inset 0 0 0 1px rgba(28, 176, 216, 0.3);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  flex-shrink: 0;
`;

export const SceneHeadText = styled.span`
  color: var(--cco-ink-mute);
  font-size: 13px;

  b,
  strong {
    color: var(--cco-cyan);
    font-weight: 700;
    margin-left: 4px;
  }
`;

// ============================================================
// SCENE — frame com aspect-ratio 16/8 envolvendo o diagrama
// ============================================================
export const SceneSection = styled.section`
  position: relative;
  /* Full-bleed total: sem padding em nenhum lado — a imagem preenche
     todo o espaco da coluna (topo, base e laterais). */
  padding: 0;
  width: 100%;
  box-sizing: border-box;
`;

export const SceneFrame = styled.div`
  position: relative;
  width: 100%;
  /* Sem aspect-ratio fixo: a altura segue a proporcao NATURAL da imagem
     (calculada no Thing). Assim a imagem e responsiva (preenche a largura,
     altura proporcional) e nao sobra espaco no quadro. */
  border-radius: 0;
  overflow: hidden;
  border: none;
  background: ${(props) => (props.theme.title === 'light' ? '#e8eaee' : '#0f1015')};

  > div,
  > svg,
  > img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

// ============================================================
// RESUMO — chip + KPI grid bordered hairline 4-col
// ============================================================
export const ResumoSection = styled.section`
  display: flex;
  flex-direction: column;
  /* margin-top auto empurra o Resumo pro fim da coluna (fica "mais
     embaixo", colado na base). Padding/gap menores = bloco compacto. */
  margin-top: auto;
  padding: 10px var(--cco-pad) 12px;
  width: 100%;
  box-sizing: border-box;
  gap: 8px;
`;

export const ResumoChip = styled.span`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  padding: 5px 12px;
  border-radius: 999px;
  background: var(--cco-cyan-soft);
  color: var(--cco-cyan);
  box-shadow: inset 0 0 0 1px rgba(28, 176, 216, 0.3);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  flex-shrink: 0;
`;

// ============================================================
// STATUS CARD wrapper — envolve OperationalStatus (5 toggles).
// ============================================================
export const StatusCard = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

// Status label pill — blue (nao cyan, conforme design)
export const StatusLabel = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 999px;
  background: var(--cco-blue-soft);
  color: var(--cco-blue);
  box-shadow: inset 0 0 0 1px rgba(78, 161, 243, 0.25);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  flex-shrink: 0;
`;

// ============================================================
// COMPAT exports — Section/SectionTag/SectionContent ainda usados
// em alguns lugares (skeleton). Mantidos como aliases minimos.
// ============================================================
export const Section = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
`;

export const SectionContent = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  min-height: 0;
`;

export const SectionTag = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 999px;
  background: var(--cco-blue-soft);
  color: var(--cco-blue);
  box-shadow: inset 0 0 0 1px rgba(78, 161, 243, 0.25);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  flex-shrink: 0;
`;

export const Line = styled.div`
  display: flex;
  width: 100%;
`;

export const ThingColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Card = styled.div`
  width: 100%;
  box-sizing: border-box;
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 3;
`;

// Aliases pra compat retroativa (algumas refs antigas)
export const AplicacaoInfoBar = SceneHead;
export const MachineLabel = SceneHead;
export const MachineLabelChip = SceneHeadChip;
export const MachineLabelText = SceneHeadText;
export const MainGrid = NewContainerBody;
export const MachineColumn = LeftColumnGrid;
export const SidebarColumn = RightColumnGrid;
